<template>
  <b-button
    class='order-pdf-exporter'
    @click='download_pdf'
    variant=link
    :disabled='busy'
    :class='{ busy, exported }'
    >
    <font-awesome-icon v-if='busy' icon='fa-solid fa-spinner' class='fa-spin' />
    <font-awesome-icon v-else-if='exported' icon='fa-solid fa-check' />
    <font-awesome-icon v-else :icon='`fa-regular fa-clipboard-list`' />
    <span>Export</span>
  </b-button>
</template>

<script>
import axios from '@/axios';
import { mapState, mapMutations } from 'vuex';
import EventBus from '@/event-bus';

export default {
  name: 'InventoryRecordPdfExporter',
  props: {
    action_block: {
      required: false,
      type: Function
    }
  },
  data () {
    return {
      busy: false,
    }
  },
  computed: {
    exported () {
      return false;//Boolean( this.order[ `${ this.type }_slip_exported` ] ?? false );
    },
    ...mapState( 'inventory_details', [
      'record',
    ]),
  },
  methods: {
    ...mapMutations( 'inventory_details', [
      'set_record_prop',
    ]),
    download_pdf () {
      if ( ( this.action_block ?? null ) && this.action_block() ) {
        return;
      }
      this.busy = true;
      EventBus.$emit( `exporting-pdf/inventory_record` );
      axios.get( `/inventory/${ this.record.id }/reports/inventory_record`, {
          responseType: 'blob',
        })
        .then( response => {
          const FILE = window.URL.createObjectURL (new Blob([ response.data ]) );
          const dl_link = document.createElement( 'a' );
          dl_link.href = FILE;
          dl_link.setAttribute( 'download', response.headers['content-disposition'].split('filename=')[1].split(';')[0] );
          document.body.appendChild( dl_link );
          dl_link.click();
          dl_link.remove();
          // this.set_order_prop({
          //   prop: `${ this.type }_slip_exported`,
          //   value: true,
          // });
        })
        .catch( () => {
          this.$jjToast({
            type: 'error',
            title: 'Error',
            content: `Failed to export inventory record`,
          });
        })
        .finally( () => {
          this.busy = false;
        })
    },
  }
}
</script>


<style>
.order-pdf-exporter {
  text-transform:capitalize;
}
</style>